import { withTopbarProps } from '@jusbrasil/topbar'
import { withUserSession } from '@jusbrasil-web/shared-user-session'
import { GetServerSideProps } from 'next'
import { useRouter } from 'next/router'
import { useCallback, useState } from 'react'

import { useChangePassword } from '../../../api'
import {
  AuthLayout,
  ChangePassword,
  ChangePasswordSubmitInput,
  PasswordResetSuccess,
} from '../../../components'
import { ERROR_MESSAGES } from '../../../utils/errorMessages'
import { isSafeRedirect } from '../../../utils/redirect-url'

const RETURN_URL = '/configuracoes'

export interface ChangePasswordPageProps {
  email?: string
  fullName?: string
}

export function ChangePasswordPage({ email, fullName }: ChangePasswordPageProps) {
  const router = useRouter()
  const { execute, loading } = useChangePassword()
  const [error, setError] = useState<string | undefined>()
  const [succeeded, setSucceeded] = useState(false)

  const handleCancel = useCallback(() => {
    const next = router.query.next_url as string | undefined
    const back = next && isSafeRedirect(next) ? next : RETURN_URL
    window.location.assign(back)
  }, [router.query.next_url])

  const handleSubmit = useCallback(
    async (input: ChangePasswordSubmitInput) => {
      setError(undefined)
      const result = await execute({
        oldPassword: input.currentPassword,
        newPassword: input.newPassword,
      })

      if (result.success) {
        setSucceeded(true)
        return
      }

      setError(
        result.kind === 'incorrectCurrent'
          ? ERROR_MESSAGES.changePassword.server.incorrectCurrent
          : ERROR_MESSAGES.changePassword.server.generic
      )
    },
    [execute]
  )

  return (
    <AuthLayout>
      {succeeded ? (
        <PasswordResetSuccess />
      ) : (
        <ChangePassword
          email={email}
          fullName={fullName}
          isLoading={loading}
          error={error}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      )}
    </AuthLayout>
  )
}

const getServerSideProps: GetServerSideProps = async (ctx) => {
  ctx.res?.setHeader('Cache-Control', 'no-cache, no-transform')
  ctx.res?.setHeader('X-Robots-Tag', 'noindex')

  return {
    props: {
      ...withTopbarProps(ctx),
      ...withUserSession(ctx),
    },
  }
}

export const ChangePasswordPageExports = {
  getServerSideProps,
}
